import Modal from "antd/lib/modal/Modal";
import React from "react";
import { useState } from "react";
import zoomIn from "../../assets/icon/zoomIn.svg";
import "./zoomIn.scss";

export default function ZoomIn({ image }) {
  const [visible, setVisible] = useState(false);
  return (
    <>
      <div className="zoom-in-icon" onClick={() => setVisible(true)}>
        <img src={zoomIn} alt="" className="" />
      </div>
      <Modal visible={visible} onCancel={() => setVisible(false)} footer={null}>
        <div className="zoomed-img">
          <img src={image} alt="" className="" />
        </div>
      </Modal>
    </>
  );
}
